'use es6';

import { useCallback } from 'react';
import { List } from 'immutable';
import { EDITOR_TYPES } from 'reporting-data/tsTypes/editorTypes';
import { useEditorComponents } from 'reporting-enablement/components/reportEditors/common/useEditorComponents';
import { ACCESSIBLE_TEAM_PROPERTY, getDimensionPropertiesForReport, getSpecificEditorSchema, hasFirstDimensionControlSupport, TEAM_GROUPING_TYPE } from '../../utils/salesAnalyticsHelpers';
import usageTracker from '../../utils/usageTracker';
import { getDimensionPropertiesForSchema } from '../../utils/editorSchemaHelpers';
import { deriveGroupingFromReport } from '../../constants/sub-app/contextDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
const FirstDimensionControl = ({
  context,
  filteredGates,
  report,
  subAppKey,
  updateContext
}) => {
  const dimensionProperties = getDimensionPropertiesForSchema(report, subAppKey, context, filteredGates);
  const handleChange = useCallback(updatedReport => {
    const isAccessibleTeams = updatedReport.getIn(['config', 'dimensions', 0], null) === ACCESSIBLE_TEAM_PROPERTY;
    const newGrouping = deriveGroupingFromReport(updatedReport, subAppKey, filteredGates);
    const contextChange = {
      grouping: newGrouping,
      drilldowns: List(),
      teamGroupingType: isAccessibleTeams ? TEAM_GROUPING_TYPE.ACCESSIBLE_TEAM : TEAM_GROUPING_TYPE.PRIMARY_TEAM
    };
    updateContext(contextChange, report);
  }, [report, subAppKey, updateContext, filteredGates]);
  const schemaFromTemplate = getSpecificEditorSchema(report, EDITOR_TYPES.DIMENSION);
  const editorSchema = schemaFromTemplate || {
    type: EDITOR_TYPES.DIMENSION,
    properties: dimensionProperties
  };
  const EditorComponents = useEditorComponents(report, [editorSchema]);
  if (dimensionProperties.length < 2 || EditorComponents.length === 0) {
    return null;
  }
  const EditorComponent = EditorComponents[0];
  return /*#__PURE__*/_jsx(EditorComponent, {
    appUsageTracker: usageTracker,
    onChange: handleChange,
    report: report
  });
};
FirstDimensionControl.isUsableForReport = ({
  report,
  subAppKey,
  filteredGates
}) => hasFirstDimensionControlSupport(report) && (Object.keys(getDimensionPropertiesForReport(subAppKey, report, filteredGates)).length > 1 || !!getSpecificEditorSchema(report, EDITOR_TYPES.DIMENSION));
export default FirstDimensionControl;